import { User } from "types";
import { flattenNestedPermissions } from "./utils/common";

/**
 * @see https://umijs.org/docs/max/access#access
 * */

export default function access(
  initialState: { currentUser?: User } | undefined
) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser ? currentUser.roles?.map((role)=>role.permissions?.map((permission)=>({[permission.action]:true}))) : [];
  const access = permissions ? flattenNestedPermissions(permissions) : {}
  return {
    // canAdmin:
    //   currentUser &&
    //   Object.values(currentUser.roles!).filter((role) => role.name === "admin")
    //     .length > 0,
    // 'user.read': currentUser && currentUser.roles?.map((role)=>role.permissions?.map((permission)=>permission.action))
    ...access
  };
}
